/**
 * @Author: Jon Lucas
 * @Date:   2017-09-29T14:00:00+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-29T14:01:49+02:00
 */

import { Component, OnInit, Input } from "@angular/core";

import { DomSanitizer, SafeUrl, SafeStyle } from "@angular/platform-browser";

import { BaseDataType } from "../../base-data-type";

import { AbstractComponent } from "../../abstract-component/abstract.component";

@Component({
    selector: "app-rectangle-button",
    templateUrl: "./rectangle-button.component.html",
    styleUrls: ["./rectangle-button.component.scss"]
})
export class RectangleButtonComponent extends AbstractComponent {

    public readonly TAG: string = "[RectangleButtonComponent]";

    public color: SafeStyle;
    public url: SafeUrl;

    @Input() public lang: string;
    @Input() public subtypeId: string;
    @Input() public elementType: BaseDataType;
    @Input() public selected: string;

    public selectedUrl: SafeUrl;
    public selectedColor: SafeStyle;

    public optionsType: BaseDataType;

    private selectedOptionType: BaseDataType;

    constructor(private sanitizer: DomSanitizer) {
        super();
    }

    /**
     * Detect if this element has options like color selection,
     * to show a pictogram.
     */
    private detectIfShowOptions(): void {
        // console.log(this.TAG, "detectIfShowOptions()", this.elementType.id);
        if (this.elementType.options && this.elementType.options.length > 0) {
            this.optionsType = this.elementType.options[0];
            this.getCurrentOptionValue();
        }
    }

    private getCurrentOptionValue(): void {
        if (!this.optionsType) { return; }

        // Check if elementType is the current saved selected type.
        const selectedValues: string[] = this.confDataService.getElementValues(this.subtypeId);
        if ( selectedValues && selectedValues.length > 0 && selectedValues[0] !== this.elementType.id)
        {
            this.selectedColor = "transparent";
            this.selectedUrl = "none";
            this.selectedOptionType = undefined;
            return;
        }

        const selectedOptions: string[] = this.confDataService.getElementOptions(this.subtypeId);
        if (selectedOptions && selectedOptions.length > 0) {
            // console.log(this.TAG, "OPTIONSTYPE", this.elementType.id, this.optionsType, selectedOptions);
            this.selectedOptionType = this.optionsType.values.find(el => el.id === selectedOptions[0]);

            if (!this.selectedOptionType || !this.selectedOptionType.values || this.selectedOptionType.values.length === 0) { return; }

            const value: string = this.selectedOptionType.values[0];
            if (value.indexOf("#") === 0) {
                this.selectedColor = this.sanitizer.bypassSecurityTrustStyle(value);
            }
            else {
                this.selectedUrl = this._detectTypeAndSanitizeUrl(value);
            }
        }
        else {
            console.log(this.TAG, "No option selected yet");
        }
    }

    /**
     * Show element's complementary information
     *
     * @param e
     */
    public showInfo(e: Event = null): void {
        if (e) {
            e.stopPropagation();
        }
        window.open(this.elementType.info[this.lang], "_blank");
    }

    /**
     * Detects url type by its extension.
     * If it is an image, show it on the button.
     * @param pValue
     */
    private _detectTypeAndSanitizeUrl(pValue: string): SafeStyle {
        const extension: string = pValue.split(".").pop().toLowerCase();
        if (extension === "jpg" || extension === "jpeg" || extension === "png" || extension === "gif") {
            return this.sanitizer.bypassSecurityTrustStyle(`url("${pValue}")`);
        }
        return;
    }

    public ngOnChanges() {

        if (this.elementType.values && this.elementType.values.length > 0) {
            const value: string | BaseDataType = this.elementType.values[0];

            this.url = "none";

            if (value && typeof value === "string") {
                value.charAt(0) === "#" ?
                    this.color = this.sanitizer.bypassSecurityTrustStyle(value) :
                    this.url = this._detectTypeAndSanitizeUrl(value);
            }
        }

        // console.log(this.TAG, this.elementType.info);

        this.detectIfShowOptions();

        this.confDataService.observable.subscribe(
            (confdata) => {
                this.getCurrentOptionValue();
            }
        );

    }

}



// WEBPACK FOOTER //
// ./src/app/ui/rectangle-button/rectangle-button.component.ts